import React from "react";
import ReactDOM from "react-dom/client";
import "./custom.scss";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import App from "./App";
import HomePage from "./pages/home/home-page";
import ToysPage from "./pages/toys-page/toys-page";
import ToysDetails from "./pages/toys-details/toys-details";
import LoginPage from "./pages/auth/login-page/login-page";
import RegisterPage from "./pages/auth/register-page/register-page";
import WeAre from "./pages/we-are/we-are";
import ContactUs from "./pages/contact-us/contact-us";
import Faq from "./pages/faq/faq";
import BeFranchise from "./pages/be-franchise/be-franchise";
import Cart from "./pages/cart/cart";

import { FranchiseContextProvider } from "./contexts/franchiseContext";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthUserContextProvider } from "./contexts/authUserContext";
import { CartContextProvider } from "./contexts/cartContext";
import { LoadingContextProvider } from "./contexts/loadingContext";
import MyOrders from "./pages/my-orders/my-orders";
import MyData from "./pages/my-data/my-data";
import Payments from "./pages/payments/payments";
import SendProof from "./pages/send-proof/send-proof";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "brinquedos-adoleta",
        element: <ToysPage />,
      },
      {
        path: "brinquedos-detalhes/:toyId",
        element: <ToysDetails />,
      },
      {
        path: "quem-somos",
        element: <WeAre />,
      },
      {
        path: "contato",
        element: <ContactUs />,
      },
      {
        path: "duvidas-frequentes",
        element: <Faq />,
      },
      {
        path: "seja-um-franqueado",
        element: <BeFranchise />,
      },
      {
        path: "carrinho",
        element: <Cart />,
      },
      {
        path: "meus-pedidos",
        element: <MyOrders />,
      },
      {
        path: "pagamentos",
        element: <Payments />,
      },
      {
        path: "enviar-comprovante",
        element: <SendProof />,
      },
      {
        path: "my-account",
        element: <MyData />,
      },
    ],
  },
  {
    path: "login",
    element: <LoginPage />,
  },
  {
    path: "cadastro",
    element: <RegisterPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <LoadingContextProvider>
    <CartContextProvider>
      <AuthUserContextProvider>
        <FranchiseContextProvider>
          <RouterProvider router={router} />
        </FranchiseContextProvider>
      </AuthUserContextProvider>
    </CartContextProvider>
  </LoadingContextProvider>
  // </React.StrictMode>
);
